// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3a0uy","rootCenter":"LoadMoreObserver_rootCenter__1ypr2","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__21KGi"};